export const SIGN_OUT_EVENT_NAME = 'SIGN_OUT';
